import axios from 'axios'
import { ConfigurationParameterGroupResponse, ConfigurationParameterPatchInBatchRequest, ConfigurationParameterResponse } from '@/modules/configurationModule/detail/parameters/services/configuration-parameters.dto'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

export default class ConfigurationParametersGlobalService {
    async getConfigurationParametersGroup(): Promise<ConfigurationParameterGroupResponse[]> {
        const response = await axios.get<ConfigurationParameterGroupResponse[]>(`/configuration/parameters/groups/global`)
        return response.data
    }

    async getConfigurationParameters(groupId: number): Promise<ConfigurationParameterResponse[]> {
        const response = await axios.get<ConfigurationParameterResponse[]>(`/configuration/parameters/groups/${groupId}`)
        return response.data
    }

    async patchConfigurationParametersBatch(request: ConfigurationParameterPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/parameters/batch`, request)
        return response.data
    }
}

export const configurationParametersGlobalService = new ConfigurationParametersGlobalService()
